export default __webpack_public_path__ + "static/school_filming-1879a0d64a032334f5e3ceec7ddec978.jpg";